import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

function NoAccess({ feature, requiredRole }) {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh'
      }}
    >
      <Paper
        sx={{
          p: 4,
          textAlign: 'center',
          maxWidth: 500,
          backgroundColor: 'background.paper'
        }}
      >
        <LockIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
        <Typography variant="h5" gutterBottom>
          Access Restricted
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          You don't have permission to view {feature || 'this page'}.
        </Typography>
        {requiredRole && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Required role: <strong>{requiredRole}</strong>
          </Typography>
        )}
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Corporation data access is typically restricted to Directors and CEOs.
          Contact your corporation leadership if you believe you should have access.
        </Typography>
        <Button
          variant="contained"
          onClick={() => navigate('/dashboard')}
        >
          Back to Dashboard
        </Button>
      </Paper>
    </Box>
  );
}

export default NoAccess;
